import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { RecentsModule } from 'apps/idl/src/modules/preferences/recents/recents.module';
import { OlaqinService } from './services/olaqin.service';



@NgModule({
	declarations: [],
	exports: [],
	imports: [
		CommonModule,
		IonicModule,
		RecentsModule.forRoot({ limit: 1 }),
	],
	providers: [OlaqinService]
})
export class OlaqinModule { }
